/** The shortest and longest code the portal takes at `/_obelisk/enter/mfa`. */
export const ENTRY_CODE_MIN = 4; export const ENTRY_CODE_MAX = 64;

/**
 * Whether a refused workspace code ends the sign-in step. Only the portal's
 * word that the step is gone does: it also answers 400 to a code too short
 * or blank to check, and that step is still there to try again (HOST-14).
 */
export function endsEntryStep(error: unknown): boolean {
  return (error as { code?: unknown } | null)?.code === 'expired_link';
}
